import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const getEditais = async (token: string) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.get(`${API_URL}/editais`, config);
  return response.data.data;
};

export default getEditais;
